import { useCallback } from "react";
import { SERVER_HOST } from "../../constants/config";
import { getEkycHeaders } from "../../utils/ekycHeaders";

const BaseAPIUrl = SERVER_HOST;

const useFaceLivenessService = () => {

  const createStreamSession = useCallback(async (params) => {
    const config = {
      headers: getEkycHeaders({ Accept: "application/json", "Content-Type": "application/json" }),
      method: "post",
      body: JSON.stringify(params),
    };

    return fetch(
      BaseAPIUrl + "/ekyc/face-liveness/createStreamSession",
      config
    ).then((response) => response.json());
  }, []);

  const getLivenessSessionResult = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders({ Accept: "application/json", "Content-Type": "application/json" }),
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/face-liveness/getLivenessSessionResult",
        config
      ).then((response) => response.json());
    },
    []
  );

  const compareProfileWithLivePerson = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/face-liveness/compare-profile-with-live-person",
        config
      ).then((response) => response.json());
    },
    []
  );

  return {
    createStreamSession,
    getLivenessSessionResult,
    compareProfileWithLivePerson,
  };
};

export { useFaceLivenessService };
